export const getValue = (item) => {
  return item === null || item === 'NaN' || item === 'Infinity' ? null : item;
}

export const numberToWords = (num) => {
  const words = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
  return words[num] || num;
};

export const capitalizeFirstWordOnly = (text) => {
  if (!text) return "";
  
  const words = text.toLowerCase().split(" ");
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);

  return words.join(" ");
};

/** Format dataset display name for non-admin: "YYYY Name" (e.g. "2025 Segment Granularity"). Year defaults to 2025. */
export const formatDatasetDisplayName = (displayName, year = '2025') => {
  if (!displayName || typeof displayName !== 'string') return displayName || ''
  const baseName = displayName.replace(/^(2024|2025)\s*-?\s*/i, '').trim()
  return baseName ? `${year} ${baseName}` : displayName
}
